import React from "react";
import styled from "styled-components";
import { useGlobalModal } from "../../../contexts/GlobalModalContext";
import { OutlinedButtonStyled } from "../OutlinedButtonStyled";
import { PrimaryButtonStyled } from "../PrimaryButtonStyled";

const BodyContent = styled.div`
    text-align: left;
    margin: 1rem;
    padding: 0.5rem;
    height: 220px;
    color: var(--slate);
`;

type ResendQuestionnaireModalBodyProps = {
    personnelId: number;
    resendQuestionnaireCallback: Function;
};

const ResendQuestionnaireModalBody: React.FC<ResendQuestionnaireModalBodyProps> = ({
    personnelId,
    resendQuestionnaireCallback,
}) => {
    return <BodyContent>Are you sure you want to resend the questionnaire?</BodyContent>;
};

const ResendQuestionnaireModalFooter: React.FC<ResendQuestionnaireModalBodyProps> = ({
    personnelId,
    resendQuestionnaireCallback,
}) => {
    const { closeModal } = useGlobalModal();

    const resendQuestionnaire = () => {
        resendQuestionnaireCallback();
    };

    return (
        <div className="d-flex">
            <PrimaryButtonStyled
                width={142}
                height={26}
                disabled={false}
                onClick={event => {
                    event.stopPropagation();
                    resendQuestionnaire();
                    closeModal();
                }}
            >
                Resend
            </PrimaryButtonStyled>
            <div className="pl-2">
                <OutlinedButtonStyled
                    width={142}
                    height={26}
                    disabled={false}
                    onClick={event => {
                        event.stopPropagation();
                        closeModal();
                    }}
                >
                    Cancel
                </OutlinedButtonStyled>
            </div>
        </div>
    );
};

ResendQuestionnaireModalBody.displayName = "BodyContent";
ResendQuestionnaireModalFooter.displayName = "FooterContent";

export { ResendQuestionnaireModalBody, ResendQuestionnaireModalFooter };
